// apps/api/src/qxcircle/qxcircle-post-update.ts
// Description: Apply local QXCircle post edits — keeps service under line cap.
// Owner: Masa Bayu
// Date: 2026-08-24

import { BadRequestException } from "./_nestjs-common";
import { normalizeQxCircleMedia } from "./qxcircle-media";
import type {
  QxCircleFeedPost,
  UpdateQxCirclePostInput,
} from "./qxcircle.types";
import { QXCIRCLE_POST_BODY_MAX } from "./qxcircle.types";

export function applyQxCirclePostUpdate(
  post: QxCircleFeedPost,
  input: UpdateQxCirclePostInput,
): void {
  const nextBody =
    input.body !== undefined ? String(input.body).trim() : post.body;
  if (nextBody.length > QXCIRCLE_POST_BODY_MAX) {
    throw new BadRequestException(
      `Post body max ${QXCIRCLE_POST_BODY_MAX} characters`,
    );
  }

  let nextMedia = post.media;
  if (input.clearMedia) {
    nextMedia = null;
  } else if (input.media !== undefined) {
    nextMedia = normalizeQxCircleMedia(input.media, post.id);
  }

  if (!nextBody && !nextMedia) {
    throw new BadRequestException("Post body or media is required");
  }

  post.body = nextBody;
  post.media = nextMedia;
  post.updatedAt = new Date().toISOString();
}
